import { FETCH_WALLET } from "../constants/wallet";

export function fetchWallet(doctorId: Number) {
  return {
    type: FETCH_WALLET,
    api: true,
    payload: {
      method: "GET",
      url: `/doctors/${doctorId}/wallets`,
    },
  };
}
